import { FontStyle } from "jspdf-autotable";
import { Transport } from "../data/api/types/schedule";
import { ReportPrinter } from "./ReportPrinter";
import { PageData } from "./usePrintJourneyListData";

export function printAutoDocuments(
  printer: ReportPrinter,
  page: PageData,
  selectedTransport: Transport
) {
  printer.withFont(
    () => {
      printer.printText(
        "ДОКУМЕНТИ ЗА ПРЕВОЗА КЪМ ПЪТНИЯ ЛИСТ",
        printer.pageMarginX + printer.printableWidth / 2,
        printer.printableWidth,
        { align: "center" }
      );
    },
    "slab-light",
    8,
    2
  );

  printer.doc.setLineDashPattern([], 0);
  printer.printSpace(-10);
  printer.autoTable({
    margin: {
      horizontal: printer.pageMarginX * 2,
      vertical: printer.pageMarginY,
    },
    styles: {
      halign: "left",
      valign: "middle",
      font: "Roboto",
      fontStyle: "slab-light" as FontStyle,
      fontSize: 10,
      lineColor: [0, 0, 0],
      lineWidth: 0,
      cellPadding: {
        horizontal: 6,
        top: 2,
        bottom: 0,
      },
      overflow: "ellipsize",
    },
    headStyles: {
      font: "Roboto",
      fontStyle: "slab-normal" as FontStyle,
      cellPadding: {
        horizontal: 6,
        vertical: 4,
      },
    },
    //columns: ["Вид обществен превоз", "Документи за превоза"],
    columns: [
      { header: { content: "Вид обществен превоз", colSpan: 1 } },
      { header: { content: "", colSpan: 1 } },
      { header: { content: "Документи за превоза", colSpan: 1 } },
      { header: { content: "", colSpan: 1 } },
      { header: { content: "", colSpan: 1 } },
      { header: { content: "", colSpan: 1 } },
    ],
    columnStyles: {
      0: {
        cellWidth: (printer.printableWidth - 2 * printer.pageMarginX) / 2 - 200,
      },
      1: {
        cellWidth: 200,
      },
      2: {
        cellWidth: (printer.printableWidth - 2 * printer.pageMarginX) / 2 - 230,
      },
      3: {
        cellWidth:
          (230 + 305 - (printer.printableWidth - 2 * printer.pageMarginX) / 2) /
          2 +
          35,
      },
      4: {
        cellWidth: (printer.printableWidth - 2 * printer.pageMarginX) / 2 - 305,
      },
      //5: {
      //  cellWidth:
      //    (230 + 305 - (printer.printableWidth - 2 * printer.pageMarginX) / 2) /
      //    2 - 35,
      //},
    },
    body: [
      [
        `1. Превоз по ${selectedTransport === "A"
          ? "автобусна "
          : selectedTransport === "TB"
            ? "тролейбусна "
            : selectedTransport === "TM"
              ? "трамвайна "
              : ""
        }линия №`,
        {
          content:
            page.documents[0] &&
              ((page.isSpecial && page.documents[0].shift === 3) ||
                (!page.isSpecial && page.documents[0].shift !== 3))
              ? page.documents[0].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "2. Разписание на линия №",
        {
          content:
            page.documents[0] &&
              ((page.isSpecial && page.documents[0].shift === 3) ||
                (!page.isSpecial && page.documents[0].shift !== 3))
              ? page.documents[0].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "кола по ред:",
        {
          content:
            page.documents[0] &&
              ((page.isSpecial && page.documents[0].shift === 3) ||
                (!page.isSpecial && page.documents[0].shift !== 3))
              ? page.documents[0].car
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
      ],
      [
        `3. Превоз по ${selectedTransport === "A"
          ? "автобусна "
          : selectedTransport === "TB"
            ? "тролейбусна "
            : selectedTransport === "TM"
              ? "трамвайна "
              : ""
        }линия №`,
        {
          content:
            page.documents[1] &&
              ((page.isSpecial && page.documents[1].shift === 3) ||
                (!page.isSpecial && page.documents[1].shift !== 3))
              ? page.documents[1].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "4. Разписание на линия №",
        {
          content:
            page.documents[1] &&
              ((page.isSpecial && page.documents[1].shift === 3) ||
                (!page.isSpecial && page.documents[1].shift !== 3))
              ? page.documents[1].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "кола по ред:",
        {
          content:
            page.documents[1] &&
              ((page.isSpecial && page.documents[1].shift === 3) ||
                (!page.isSpecial && page.documents[1].shift !== 3))
              ? page.documents[1].car
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
      ],
      [
        `5. Превоз по ${selectedTransport === "A"
          ? "автобусна "
          : selectedTransport === "TB"
            ? "тролейбусна "
            : selectedTransport === "TM"
              ? "трамвайна "
              : ""
        }линия №`,
        {
          content:
            page.documents[2] &&
              ((page.isSpecial && page.documents[2].shift === 3) ||
                (!page.isSpecial && page.documents[2].shift !== 3))
              ? page.documents[2].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "6. Разписание на линия №",
        {
          content:
            page.documents[2] &&
              ((page.isSpecial && page.documents[2].shift === 3) ||
                (!page.isSpecial && page.documents[2].shift !== 3))
              ? page.documents[2].line
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "кола по ред:",
        {
          content:
            page.documents[2] &&
              ((page.isSpecial && page.documents[2].shift === 3) ||
                (!page.isSpecial && page.documents[2].shift !== 3))
              ? page.documents[2].car
              : "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
      ],
      [
        "",
        {
          content: "",
          styles: { fontStyle: "slab-bold" as FontStyle, fontSize: 14 },
        },
        "",
        "",
        "",
        "",
      ],
    ],
    didDrawCell: (cell) => {
      //console.log(cell);
      // top
      cell.doc.line(
        cell.cell.x,
        cell.cell.y,
        cell.cell.x + cell.cell.width,
        cell.cell.y
      );
      // bottom
      cell.doc.line(
        cell.cell.x,
        cell.cell.y + cell.cell.height,
        cell.cell.x + cell.cell.width,
        cell.cell.y + cell.cell.height
      );

      if (cell.column.index === 0) {
        // left
        cell.doc.line(
          cell.cell.x,
          cell.cell.y,
          cell.cell.x,
          cell.cell.y + cell.cell.height
        );
      }

      if (cell.column.index === 1 || cell.column.index === 5) {
        // right
        cell.doc.line(
          cell.cell.x + cell.cell.width,
          cell.cell.y,
          cell.cell.x + cell.cell.width,
          cell.cell.y + cell.cell.height
        );
      }
    },
  });
}
